export const VerifiedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 28 28" fill="none">
      <g clip-path="url(#clip0_3780_90375)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 1.93292L11.7457 0.830947C10.4037 0.174956 8.78333 0.70146 8.08324 2.02095L6.90719 4.23752L4.43569 4.67105C2.96443 4.92913 1.96298 6.30753 2.17217 7.78651L2.52359 10.271L0.778929 12.0745C-0.259646 13.148 -0.25964 14.8518 0.778929 15.9254L2.52359 17.7288L2.17217 20.2134C1.96298 21.6923 2.96443 23.0707 4.43569 23.3288L6.90719 23.7624L8.08324 25.9789C8.78334 27.2984 10.4037 27.8249 11.7457 27.1689L14 26.0669L16.2543 27.1689C17.5962 27.8249 19.2166 27.2985 19.9168 25.9789L21.0928 23.7623L23.5643 23.3288C25.0356 23.0707 26.037 21.6923 25.8278 20.2133L25.4764 17.7288L27.2211 15.9254C28.2597 14.8518 28.2596 13.148 27.2211 12.0745L25.4764 10.271L25.8278 7.78651C26.037 6.30755 25.0356 4.92913 23.5643 4.67105L21.0928 4.23752L19.9168 2.02095C19.2167 0.70145 17.5963 0.17496 16.2543 0.830946L14 1.93292Z"
          fill="#F8F7FA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.4867 6.44913L17.6059 2.9043L14.0007 4.66662L10.3955 2.9043L8.51466 6.44913L4.56212 7.14246L5.12412 11.1158L2.33398 14L5.12412 16.8841L4.56212 20.8575L8.51466 21.5508L10.3955 25.0956L14.0007 23.3333L17.6059 25.0956L19.4867 21.5508L23.4392 20.8575L22.8772 16.8841L25.6673 14L22.8772 11.1158L23.4392 7.14246L19.4867 6.44913ZM8.16773 14.0296L9.66766 12.5297L12.3829 15.245L17.8703 9.75755L19.3702 11.2575L12.3829 18.2448L8.16773 14.0296Z"
          fill="#FF5E30"
        />
      </g>
      <defs>
        <clipPath id="clip0_3780_90375">
          <path
            d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
